import { useQuery } from '@tanstack/react-query';
import { IpedsResult } from '@common-types';
import { getSchools } from '@api/schools';
import useSchoolSearchFiltersStore from '@store/SchoolSearchFiltersStore';
import useStateSpotlightStore, { selectIsWaitingForDefaults } from '@store/StateSpotlightStore';

interface UseSchoolsReturn {
  data: IpedsResult | undefined;
  refetch: () => Promise<unknown>;
  isLoading: boolean;
}

interface UseSchoolsProps {
  filterByMajor?: boolean;
}

export const useSchools = ({ filterByMajor = false }: UseSchoolsProps = {}): UseSchoolsReturn => {
  const filters = useSchoolSearchFiltersStore((state) => state.filters);
  const sortByValues = useSchoolSearchFiltersStore((state) => state.sortByValues);
  const isWaitingForDefaults = useStateSpotlightStore(selectIsWaitingForDefaults('schools')) && !filterByMajor;

  const query = useQuery<IpedsResult>({
    queryKey: ['schools', filters, filterByMajor, sortByValues],
    queryFn: () => getSchools({ filters, filterByMajor, sortByValues }),
    enabled: !isWaitingForDefaults && Object.keys(filters).length > 0,
    refetchOnWindowFocus: false,
    staleTime: 0,
    gcTime: 0,
  });

  return {
    data: query.data,
    refetch: () => query.refetch(),
    isLoading: query.isLoading || isWaitingForDefaults,
  };
};
